var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.state === "loggedIn"
    ? _c("li", { class: "sub" }, [
        _c("div", { staticClass: "loginStatus" }, [
          _c(
            "a",
            {
              class: "loginStatus__link test-statusLogin " + _vm.linkClass,
              attrs: { href: "javascript:void(0);", title: "" + _vm.myAccount }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.myAccount) + "\n      "),
              _c("span", { staticClass: "arrow arrowDown" })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "loginStatus__popup" }, [
            _c("div", [
              _vm._v(_vm._s(_vm.label.loggedInAs) + " " + _vm._s(_vm.username))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "test-myData button button--wide",
                attrs: { href: _vm.myDataUrl }
              },
              [_vm._v(_vm._s(_vm.label.myData))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "test-logout button button--wide",
                attrs: { href: _vm.logoutUrl }
              },
              [_vm._v(_vm._s(_vm.label.logout))]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }